import axios from "../../utils/axiosConfig";
import {
  AddStaffPermissionsDTO,
  DeleteClinicStaffDTO,
  EditStaffProfileDTO,
  getStaffPermissionsDTO,
  getStaffProfileDTO,
  RegisterStaffPermissionDTO,
  EditStaffDataDTO,
  EditStaffStatusDTO,
  getStaffPerByIdDTO,
  addPharmcyPermissionDTO,
  staffLoginDTO,
  ActiveStatfDTO
  
} from "../../dtos/staff";
import decryptResponse from "../../utils/decrypt_new";
const getStaffProfile = async (dto: getStaffProfileDTO) => {
  const url = `/api/staff/profile/get?clinic_id=${encodeURIComponent(
    dto.clinic_id
  )}&staff_id=${encodeURIComponent(dto.staff_id)}`;
  const { data } = await axios.get(url);
  return data;
};

const getAllStaff = async (id: string) => {
  const url = `/api/clinic/staff?clinic_id=${encodeURIComponent(id)}`;
  const { data } = await axios.get(url);
  return data;
};
const getAllPharmacyPermission = async () => {
  const url = `/api/pharmacy_components/get`;
  const { data } = await axios.get(url);
  
  return data;
};

const registerStaffPermission = async (staffPermission: RegisterStaffPermissionDTO) => {
  const { data } = await axios.post("/api/pharmacy_staff/add_pharmacy_staff", staffPermission);
  return data;
};

const getAllStaffPermissions = async (id: number) => {
  try {
    const { data } = await axios.get("/api/pharmacy_staff/get_pharmacy_staff", {
      params: { pharmacy_id: id },
    });
    if (data?.data?.encryptedData && data?.data?.iv) {
      
      const decryptedResponse = await decryptResponse(
        data?.data?.encryptedData,
        data?.data.iv
      );

    
      

      if (decryptedResponse?.staffWithCredentials) {
        return decryptedResponse.staffWithCredentials;
      } else {
        throw new Error("Decrypted response is missing staffWithCredentials");
      }
    } else {
      throw new Error("Missing encryptedData or iv in response");
    }
  } catch (error) {
    console.error("Error fetching staff permissions:", error);
    throw new Error("Failed to fetch staff permissions");
  }
};

const getActiveStaff = async (activeStaff: ActiveStatfDTO) => {
  try {
    const { data } = await axios.get("/api/pharmacy_staff_activity/get_staff_activity_by_id", {
      params: { pharmacy_id: activeStaff.pharmacy_id, staff_id: activeStaff.staff_id },
    });

    if (data?.data?.encryptedData && data?.data?.iv) {
      const decryptedResponse = await decryptResponse(
        data.data.encryptedData,
        data.data.iv
      );

      if (decryptedResponse?.acitvity) {
        const activity = decryptedResponse.acitvity;

        // Ensure activity is an array
        if (Array.isArray(activity)) {
          
          return activity; // Return the array directly
        } else {
          throw new Error("Decrypted response activity is not an array");
        }
      } else {
        throw new Error("Decrypted response is missing activity");
      }
    } else {
      throw new Error("Missing encryptedData or iv in response");
    }
  } catch (error) {
    console.error("Error fetching staff permissions:", error);
    throw new Error("Failed to fetch staff permissions");
  }
};






const editStaffData = async (staff: EditStaffDataDTO) => {
  const { data } = await axios.put("/api/pharmacy_staff/update_pharmacy_staff", staff);
  return data;
};
const staffStatus = async (staff: EditStaffStatusDTO) => {
  const { data } = await axios.put("/api/pharmacy_staff/status_pharmacy_staff", staff);
  return data;
};


const addPharmcyPermission = async (staffPermission: addPharmcyPermissionDTO) => {
  const { data } = await axios.post("/api/pharmacy_staff/add_pharmacy_staff_permission", staffPermission);
  return data;
};

const deletePharmcyPermission = async (staffPermission: addPharmcyPermissionDTO) => {
  const { data } = await axios.delete("/api/pharmacy_staff/delete_pharmacy_staff_permission", {data: staffPermission});
  return data;
};



const deleteClinicStaff = async (dto: DeleteClinicStaffDTO) => {
  const { data } = await axios.delete(
    `/api/clinic/delete-staff?clinic_id=${dto.clinic_id}&staff_id=${dto.staff_id}`
  );
  return data;
};

const getStaffPermissions = async (staff: getStaffPermissionsDTO) => {
  const url = `/api/staff/permissions/get?staff_id=${encodeURIComponent(
    staff.staff_id
  )}&clinic_id=${encodeURIComponent(staff.clinic_id)}`;
  const { data } = await axios.get(url);
  return data;
};


const getStaffPerById = async (staff: getStaffPerByIdDTO) => {
  const url = `/api/pharmacy_staff/get_pharmacy_staff_permission?pharmacy_id=${encodeURIComponent(
    staff.pharmacy_id
  )}&staff_id=${encodeURIComponent(staff.staff_id)}`;
  const { data } = await axios.get(url);
  return data;
};

const addPermissions = async (staff: AddStaffPermissionsDTO) => {
  const { data } = await axios.post("/api/staff/permissions/add", staff);
  return data;
};

const deletePermissions = async (staff: AddStaffPermissionsDTO) => {
  const { data } = await axios.post("/api/staff/permissions/delete", staff);
  return data;
};
const editStaffInfo = async (staff: EditStaffProfileDTO) => {
  const { data } = await axios.post("/api/staff/edit", staff);
  return data;
};


const staffLogin = async (stafflogin: staffLoginDTO) => {
  const { data } = await axios.post("/api/pharmacy_staff/login_pharmacy_staff", stafflogin);
  return data;
};

const staffLogout = async (bearerToken: string) => {
  const { data } = await axios.post(
    "/api/pharmacy_staff/logout_pharmacy_staff",
    {}, 
    {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
    }
  );
  return data;
};


const staffService = {
  getStaffProfile,
  getAllStaff,
  registerStaffPermission,
  getStaffPermissions,
  addPermissions,
  deletePermissions,
  editStaffInfo,
  deleteClinicStaff,
  getAllStaffPermissions,
  editStaffData,
  staffStatus,
  getAllPharmacyPermission,
  getStaffPerById,
  addPharmcyPermission,
  deletePharmcyPermission,
  staffLogin,
  getActiveStaff,
  staffLogout
};

export default staffService;
